import css from 'styled-jsx/css';

export default css.global`.faq-collapse-trigger {
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  border-radius: 5px;
  cursor: pointer;
}

.faq-collapse-trigger p {
  margin: 0;
  color: grey;
  font-weight: bold;
  font-size: 1.5rem;
}

.Collapsible {
  margin-bottom: 2rem;
}
`